module.exports = __webpack_public_path__ + "img/cards-header.deaaa3b1.png";